export default {
  setApiSign(state, value) {
    state.apiSign = value
  },
  changeStore(state, params = {}) {
    Object.assign(state, params)
  },
  setBrandUpgradeNoticeVisible(state, visible) {
    state.brandUpgradeNoticeVisible = !!visible
  },
}
